import { render, staticRenderFns } from "./PageMe.vue?vue&type=template&id=5ee47bc1&"
import script from "./PageMe.vue?vue&type=script&lang=js&"
export * from "./PageMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ee47bc1')) {
      api.createRecord('5ee47bc1', component.options)
    } else {
      api.reload('5ee47bc1', component.options)
    }
    module.hot.accept("./PageMe.vue?vue&type=template&id=5ee47bc1&", function () {
      api.rerender('5ee47bc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageMe.vue"
export default component.exports